import React from "react";

const Time: React.FC<{ time: number; type: string; isLast?: boolean; isDate?: boolean }> = ({
  time,
  type,
  isLast,
  isDate,
}) => {
  return (
    <div>
      {isDate && time <= 0 ? (
        <></>
      ) : (
        <div className="leading-[119%] flex gap-y-2">
          <div>
            <p className="text-[42px] md:text-[57px] font-second">{time < 10 ? `0${time}` : time}</p>
            <p className="text-sm text-gray-200 text-[14px] mt-[18px]">
              {type}
              {time > 1 ? "s" : ""}
            </p>
          </div>
          {!isLast && <p className="px-4 md:px-[27px] font-second text-[42px] md:text-[57px]">:</p>}
        </div>
      )}
    </div>
  );
};
export default React.memo(Time);
